<ng-container *ngIf="viewModel$ | async as vm">
  <app-scales [selectedScale]="vm.scale" (selectedScaleChange)="selectScale($event)"></app-scales>
</ng-container>